import { useOutletContext } from 'react-router-dom';
import type { AdminAgentDetail } from '@wlb/shared/api/agent/agentAdminTypes';

/**
 * What the agent detail layout hands to its sub-modules.
 *
 * The record is fetched once by the parent route, so switching sub-module does
 * not refetch it and cannot blank the screen — the tabs only swap the panel
 * under the header.
 */
export interface AgentDetailContext {
  agent: AdminAgentDetail;
  /** Refetches the record after a write, keeping the rendered copy meanwhile. */
  reload: () => void;
}

export const useAgentDetail = (): AgentDetailContext =>
  useOutletContext<AgentDetailContext>();
